import { html, nothing } from "lit";
import type { ExecutionProfileRecord } from "./types";
import { formatAgo } from "../../format";

export type ProfileCardProps = {
  profile: ExecutionProfileRecord;
  selected: boolean;
  onSelect: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onRun: () => void;
};

const ARCHITECTURE_ICONS: Record<string, string> = {
  sequential: "→",
  supervisor: "⤵",
  parallel: "⤴",
  custom: "⬡",
};

export function renderExecutionProfileCard(props: ProfileCardProps) {
  const { profile, selected, onSelect, onDuplicate, onDelete, onRun } = props;

  const archIcon = ARCHITECTURE_ICONS[profile.architectureType] ?? "⬡";
  const archLabel =
    profile.architectureType.charAt(0).toUpperCase() + profile.architectureType.slice(1);

  return html`
    <div class="ma-profile-card ${selected ? "ma-profile-card--selected" : ""}">
      <div class="ma-profile-card-header" @click=${onSelect}>
        <div class="ma-profile-card-arch">
          <span class="ma-arch-icon">${archIcon}</span>
          <span class="ma-arch-label">${archLabel}</span>
        </div>
        ${
          profile.lastUsedAt
            ? html`<span class="muted" style="font-size: 11px;">${formatAgo(profile.lastUsedAt)}</span>`
            : nothing
        }
      </div>

      <div class="ma-profile-card-body" @click=${onSelect}>
        <div class="ma-profile-card-name">${profile.name}</div>
        ${
          profile.description
            ? html`<div class="ma-profile-card-desc muted">${profile.description}</div>`
            : nothing
        }

        <div class="ma-profile-card-meta">
          <span class="ma-badge">${profile.agents.length} agent${profile.agents.length !== 1 ? "s" : ""}</span>
          ${
            profile.runCount > 0
              ? html`<span class="ma-badge ma-badge--muted">${profile.runCount} runs</span>`
              : nothing
          }
        </div>
      </div>

      <div class="ma-profile-card-actions row">
        <button class="btn btn--sm primary" @click=${onRun}>▶ Run</button>
        <button class="btn btn--sm" @click=${onSelect}>Edit</button>
        <button class="btn btn--sm" @click=${onDuplicate} title="Duplicate">⧉</button>
        <button
          class="btn btn--sm btn--danger"
          @click=${onDelete}
          title="Delete"
        >
          ✕
        </button>
      </div>
    </div>
  `;
}
